// extracted by mini-css-extract-plugin
export default {"content":"content__zEvpoQax","actions":"actions__WLIWdvTX"};